import { render } from "./branch-pc.vue?vue&type=template&id=6ff146e7&ts=true"
import script from "./branch-pc.vue?vue&type=script&lang=ts"
export * from "./branch-pc.vue?vue&type=script&lang=ts"

import "./branch-pc.vue?vue&type=style&index=0&id=6ff146e7&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__